import {requestRemoteData} from '../../API/api';
import {isSuccess} from '../../common/domain/RemoteData.model';

const PARKED_ENDPOINT = 'orders/parked';

/**
 * Evento global que se dispara tras cada mutación de carritos aparcados que llega
 * bien al backend (aparcar, recuperar, eliminar). El badge del navbar y el panel
 * lo escuchan y se refrescan solos, igual que hace pendientes.
 */
export const PARKED_CARTS_CHANGED_EVENT = 'parked-carts-changed';

const notifyIfChanged = (result) => {
  if (isSuccess(result)) {
    window.dispatchEvent(new Event(PARKED_CARTS_CHANGED_EVENT));
  }
  return result;
};

/**
 * @typedef {Object} ParkedCart
 * @property {number} id
 * @property {string} numCliente - Cliente al que estaba asociado el carrito al aparcarlo.
 * @property {string} nombreRazonSocial
 * @property {string} createdAt - Fecha de guardado (identifica el aparcado junto al cliente).
 * @property {number} lineCount
 * @property {number} totalUnits
 */

/**
 * Carritos aparcados del comercial logueado (todos, con su cliente visible).
 * No lleva X-Acting-As-Client: el backend lo deriva todo del usuario y del carrito.
 * @returns {Promise<RemoteData<ParkedCart[]>>}
 */
export const fetchParkedCarts = () => {
  return requestRemoteData(PARKED_ENDPOINT);
};

/**
 * Aparca el carrito activo: mueve sus líneas a un guardado asociado al cliente
 * efectivo del carrito y deja el carrito vacío. 409 si está vacío o sin cliente.
 * @returns {Promise<RemoteData<ParkedCart>>}
 */
export const parkCurrentCart = () => {
  return requestRemoteData(PARKED_ENDPOINT, {method: 'POST'}).then(notifyIfChanged);
};

/**
 * Restaura un aparcado como carrito activo. Si el activo tenía líneas, el backend
 * lo aparca primero con su propio cliente (no se pierde nada).
 * @param {number} parkedCartId
 * @returns {Promise<RemoteData<Object>>} el carrito restaurado (formato de GET cart)
 */
export const restoreParkedCart = (parkedCartId) => {
  return requestRemoteData(
    `${PARKED_ENDPOINT}/${parkedCartId}/restore`,
    {method: 'POST'}
  ).then(notifyIfChanged);
};

/**
 * Elimina un aparcado sin restaurarlo.
 * @param {number} parkedCartId
 * @returns {Promise<RemoteData<void>>}
 */
export const deleteParkedCart = (parkedCartId) => {
  return requestRemoteData(
    `${PARKED_ENDPOINT}/${parkedCartId}`,
    {method: 'DELETE'}
  ).then(notifyIfChanged);
};
